import { render, staticRenderFns } from "./PreviewSchoolFooterSection.vue?vue&type=template&id=77c74052&"
import script from "./PreviewSchoolFooterSection.vue?vue&type=script&lang=js&"
export * from "./PreviewSchoolFooterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports